import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
import _cloneDeep from "lodash/cloneDeep";

var _dec, _dec2, _dec3, _dec4, _class, _class2, _descriptor, _descriptor2, _descriptor3;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { TYPES } from '@antv/l7-core';
import { rgb2arr } from '@antv/l7-utils';
import { inject, injectable } from 'inversify';
import 'reflect-metadata';
var DataMappingPlugin = (_dec = injectable(), _dec2 = inject(TYPES.IGlobalConfigService), _dec3 = inject(TYPES.IMapService), _dec4 = inject(TYPES.IFontService), _dec(_class = (_class2 = function () {
  function DataMappingPlugin() {
    _classCallCheck(this, DataMappingPlugin);

    _initializerDefineProperty(this, "configService", _descriptor, this);

    _initializerDefineProperty(this, "mapService", _descriptor2, this);

    _initializerDefineProperty(this, "fontService", _descriptor3, this);
  }

  _createClass(DataMappingPlugin, [{
    key: "apply",
    value: function apply(layer, _ref) {
      var _this = this;

      var styleAttributeService = _ref.styleAttributeService;
      layer.hooks.init.tap('DataMappingPlugin', function () {
        _this.generateMaping(layer, {
          styleAttributeService: styleAttributeService
        });
      });
      layer.hooks.beforeRenderData.tap('DataMappingPlugin', function () {
        layer.dataState.dataMappingNeedUpdate = false;

        _this.generateMaping(layer, {
          styleAttributeService: styleAttributeService
        });

        return true;
      });
      layer.hooks.beforeRender.tap('DataMappingPlugin', function () {
        if (layer.layerModelNeedUpdate) {
          return;
        }

        var attributes = styleAttributeService.getLayerStyleAttributes() || [];
        var filter = styleAttributeService.getLayerStyleAttribute('filter');
        var dataArray = layer.getSource().data.dataArray;
        var attributesToRemapping = attributes.filter(function (attribute) {
          return attribute.needRemapping;
        });
        var filterData = dataArray;

        if (filter !== null && filter !== void 0 && filter.needRemapping && filter !== null && filter !== void 0 && filter.scale) {
          filterData = dataArray.filter(function (record) {
            return _this.applyAttributeMapping(filter, record)[0];
          });
        }

        if (attributesToRemapping.length) {
          if (filter !== null && filter !== void 0 && filter.needRemapping) {
            layer.setEncodedData(_this.mapping(attributes, filterData));
            filter.needRemapping = false;
          } else {
            layer.setEncodedData(_this.mapping(attributesToRemapping, filterData, layer.getEncodedData()));
          }

          layer.emit('remapping', null);
        }
      });
    }
  }, {
    key: "generateMaping",
    value: function generateMaping(layer, _ref2) {
      var _this2 = this;

      var styleAttributeService = _ref2.styleAttributeService;
      var attributes = styleAttributeService.getLayerStyleAttributes() || [];
      var filter = styleAttributeService.getLayerStyleAttribute('filter');
      var dataArray = layer.getSource().data.dataArray;
      var filterData = dataArray;

      if (filter !== null && filter !== void 0 && filter.scale) {
        filterData = dataArray.filter(function (record) {
          return _this2.applyAttributeMapping(filter, record)[0];
        });
      }

      layer.setEncodedData(this.mapping(attributes, filterData));
    }
  }, {
    key: "mapping",
    value: function mapping(attributes, data, predata) {
      var _this3 = this;

      var mappedData = data.map(function (record, i) {
        var preRecord = predata ? predata[i] : {};

        var encodeRecord = _objectSpread({
          id: record._id,
          coordinates: record.coordinates
        }, preRecord);

        attributes.filter(function (attribute) {
          return attribute.scale !== undefined;
        }).forEach(function (attribute) {
          var values = _this3.applyAttributeMapping(attribute, record);

          attribute.needRemapping = false;

          if (attribute.name === 'color') {
            values = values.map(function (c) {
              return rgb2arr(c);
            });
          }

          encodeRecord[attribute.name] = Array.isArray(values) && values.length === 1 ? values[0] : values;

          if (attribute.name === 'shape') {
            encodeRecord.shape = _this3.fontService.getIconFontKey(encodeRecord[attribute.name]);
          }
        });
        return encodeRecord;
      });

      if (mappedData.length > 0 && this.mapService.version === 'GAODE2.x') {
        if (typeof mappedData[0].coordinates[0] === 'number') {
          mappedData.filter(function (d) {
            return !d.originCoordinates;
          }).map(function (d) {
            d.version = 'GAODE2.x';
            d.originCoordinates = _cloneDeep(d.coordinates);
            d.coordinates = _this3.mapService.lngLatToCoord(d.coordinates);
          });
        } else {
          mappedData.filter(function (d) {
            return !d.originCoordinates;
          }).map(function (d) {
            d.version = 'GAODE2.x';
            d.originCoordinates = _cloneDeep(d.coordinates);
            d.coordinates = _this3.mapService.lngLatToCoords(d.coordinates);
          });
        }
      }

      return mappedData;
    }
  }, {
    key: "applyAttributeMapping",
    value: function applyAttributeMapping(attribute, record) {
      var _attribute$scale;

      if (!attribute.scale) {
        return [];
      }

      var scalers = (attribute === null || attribute === void 0 ? void 0 : (_attribute$scale = attribute.scale) === null || _attribute$scale === void 0 ? void 0 : _attribute$scale.scalers) || [];
      var params = [];
      scalers.forEach(function (_ref3) {
        var _attribute$scale2;

        var field = _ref3.field;

        if (record.hasOwnProperty(field) || ((_attribute$scale2 = attribute.scale) === null || _attribute$scale2 === void 0 ? void 0 : _attribute$scale2.type) === 'variable') {
          params.push(record[field]);
        }
      });
      return attribute.mapping ? attribute.mapping(params) : [];
    }
  }]);

  return DataMappingPlugin;
}(), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "configService", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "mapService", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "fontService", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class2)) || _class);
export { DataMappingPlugin as default };
//# sourceMappingURL=DataMappingPlugin.js.map